<template>
    <app-modal :modal-id="modalId"
               :modal-size="modalSize"
               :modal-alignment="modalAlignment"
               @close-modal="closeModal"
               :modal-scroll="modalScroll"
               :modal-body-class="modalBodyClass">
        <template slot="header">
            <h5 class="modal-title">{{ title }}</h5>
            <button type="button"
                    class="close outline-none"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click.prevent="closeModal">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>

        <template slot="body">
            <slot name="body"></slot>
        </template>

        <template slot="footer">
            <div :class="{'loading-opacity': preloader}" v-if="isNeedButtonFooter">
                <button type="button"
                        class="btn btn-secondary mr-2"
                        data-dismiss="modal"
                        @click.prevent="closeModal">
                    Close
                </button>
            </div>
        </template>
    </app-modal>
</template>
<script>
    export default {
        name: "DetailModal",

        props: {
            title: String,
            modalId: String,
            preloader: {
                type: Boolean,
                default: false
            },
            modalScroll: {
                type: Boolean,
                default: true,
            },
            modalBodyClass: {},
            modalSize: {
                type: String,
                default: 'default'
            },
            modalAlignment: {
                type: String,
                default: 'top'
            },
            isNeedButtonFooter: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            closeModal() {
                this.$emit('close-modal');
            },
        }
    }
</script>
